<div class="grid-x grid-margin-x">
  <div class="cell large-12 medium-12 small-12">
    <span class="bold margin-right">{{label}}:</span>@if (enabled) {
    <button class="button" [disabled]="pendingNote != null" (click)="addNote()">Add</button>
    <span class="bold margin-left">*Any notes added will be attached to all requested adjustments.</span>
  }
</div>
@if (pendingNote != null) {
  <div class="cell large-6 medium-6 small-6 text-align-left">
    <span class="bold minor-margin-right">Created By:</span>{{pendingNote.createdByName}}
  </div>
  <div class="cell large-6 medium-6 small-6 text-align-right">
    {{ pendingNote.createdDate | date: 'MM/dd/yyyy | h:mma'}}
  </div>
  <div class="cell large-12 medium-12 small-12">
    <text-editor (formBuilt)="editorFormBuilt($event)" [required]="true"></text-editor>
  </div>
  <div class="cell large-12 medium-12 small-12 major-margin-top">
    <span class="minor-margin-right">
      <button (click)="submitNote()" class="button" [disabled]="disableSave">Save</button>
    </span>
    <span class="minor-margin-left">
      <button (click)="cancel()" class="button">Cancel</button>
    </span>
    <text-loader [run]="savingNote?.value" [text]="'Saving'" [tickType]="'.'" [interval]="1000"></text-loader>
  </div>
}
</div>
@if (notes != null) {
  <div class="note-group">
    @for (note of notes; track note; let i = $index) {
      <div class="grid-x grid-margin-x notes" [ngClass]="{ 'private-note': note.type < 2, 'public-note': note.type == noteType.General, 'clarification-note': note.type === noteType.Clarification  }">
        <div class="cell large-6 medium-6 small-6 text-align-left">
          <span class="bold minor-margin-right">Created By:</span>{{note.createdByName}}
        </div>
        <div class="cell large-6 medium-6 small-6 text-align-right">
          {{ note.createdDate | date: 'MM/dd/yyyy | h:mma' }}@if (showDelete(note.createdById)) {
          <span class="padding-left"><button (click)="deleteNote(i)"><svg-icon icon="icon-trash" class="small gray"></svg-icon></button></span>
        }
      </div>
      <div class="cell large-12 medium-12 small-12" [innerHTML]="note.text">
      </div>
    </div>
  }
</div>
}
